<template>
  <ul id="sideSchedule" ref="anchorBox">
    <li
      v-for="(arrange, key) in arrangeList"
      :key="key"
      :class="{ anchor: arrange.status === 3 }"
      @click="showTeams(arrange)"
    >
      <div class="header">
        <div class="title">
          <div class="bg"></div>
          <div class="label-box">
            <span class="label-shadow">{{ arrange.title }}</span>
            <span class="label-text">{{ arrange.title }}</span>
          </div>
        </div>
        <div class="time">
          <div class="label-box">
            <span class="label-shadow">{{ arrange.day }} {{ arrange.time }}</span>
            <span class="label-text">{{ arrange.day }} {{ arrange.time }}</span>
          </div>
        </div>
      </div>
      <ul class="teams">
        <li
          v-for="i in 7"
          :key="i"
          :name="i"
          :style="{
            'background-image': `url(${
              arrange.teams[i - 1] ? arrange.teams[i - 1].avatar||defaultAvatar : defaultAvatar
            })`,
          }"
        ></li>
        <li name="8"></li>
      </ul>
      <div class="bottom">
        <div class="status">
          <div :class="[{
            'gray': arrange.status == 1||arrange.status== 3,
            'yellow': arrange.status == 2
          }]">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.status | getStatus }}</span>
              <span class="label-text">{{ arrange.status | getStatus }}</span>
            </div>
          </div>
        </div>
      
        <ui-frame-bg
          class="details"
          colorType="blue"
          :class="{ hasPoints: arrange.status != 1 }"
          @click.native="(e) => showScores(e,
            arrange,
            `${arrange.day ? arrange.day : ''} ${
              arrange.week ? arrange.week : ''
            } ${arrange.title ? arrange.title : ''}`
          )"
        >
          <div class="label-box">
            <span class="label-shadow">积分详情</span>
            <span class="label-text">积分详情</span>
          </div>
          <i></i>
        </ui-frame-bg>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import UiFrameBg from "@/components/ui-frame-bg";

export default {
  components: {
    UiFrameBg,
  },
  props: {
    scoreModal: {
      type: Function,
      default: () => {},
    },
    teamsModal: {
      type: Function,
      default: () => {},
    },
    arrangeList: {
      type: Array,
      default: () => [],
    },
    handleAnchor: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["token"]),
  },
  data() {
    return {
      // arrangeList: [],
      subPhase: "",
      phaseID: "",
      defaultAvatar: "https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png"
    };
  },
  watch: {
    arrangeList() {
      this.$nextTick(() => {
        let $anchorBox = this.$refs.anchorBox,
          $anchors = document.getElementsByClassName("anchor");
        if ($anchors && $anchors.length != 0) {
          let $end = $anchors[$anchors.length - 1];
          let offsetTop = $end.offsetTop - $anchorBox.offsetTop;
          this.handleAnchor(offsetTop);
        }
      });
    },
  },
  filters: {
    getStatus: (value) => {
      let subStatus = "";
      switch (Number(value)) {
        case 1:
          subStatus = "未开始";
          break;
        case 2:
          subStatus = "进行中";
          break;
        case 3:
          subStatus = "已结束";
          break;
      }

      return subStatus;
    },
    getDetailsText: (arrange) => {
      let text = "";
      if (arrange && arrange.status != 1) {
        text = "积分详情";
      } else {
        text = "参赛战队";
      }

      return text;
    },
  },
  methods: {
    showTeams(arrange) {
      // 参赛战队
      this.teamsModal(arrange.teams ? arrange.teams : []);

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('查看队伍 - 直播', {
        '#schedule_id': arrange.title,
      });
    },
    showScores(e, arrange, title) {
      e.stopPropagation();

      // 积分详情
      this.scoreModal(arrange.scheduleCode, title);

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('查看对局 - 直播', {
        '#schedule_id': arrange.title,
        "#match_id": '总积分'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/live/sideSchedule";
</style>